import { UI } from '@genial/components';

import { DirectTreasuryDetailsModalComponentsProps } from '../..';

import { directTreasuryDetailTexts } from './constants';

export const DirectTreasuryDetailsPrincipalText = ({
  item,
}: DirectTreasuryDetailsModalComponentsProps) => {
  const mountText = () => {
    return [
      directTreasuryDetailTexts.initial(item),
      directTreasuryDetailTexts.middle(item),
      directTreasuryDetailTexts.end(item),
    ].join(' ');
  };

  return <UI.Text color="brand.primary.principal">{mountText()}</UI.Text>;
};
